import React from 'react';

import TextBox from '@components/TextBox/TextBox';

import Css from './Benefits.scss';
import ImportImages from '@src/importImages';

const Section = ImportImages('/slider/section_2.jpg');

const benefits = props => {
  let heightStyle = {
    textAlign: 'justify'
  };

  if (window.innerWidth < 992) {
    heightStyle.minHeight = props.screenHeight + 'px';
  } else {
    heightStyle.height = props.screenHeight + 'px';
  }

  return (
    <div id={props.id} className={props.className} style={heightStyle}>
      <img
        src={Section}
        alt={'Slider1'}
        className={'img-fluid img-mobile-background'}
        style={{ minHeight: '100%' }}
      />
      <div className={Css.content + ' d-flex align-items-center'}>
        <div className={'ml-auto ' + Css['text-box']}>
          <TextBox {...props} isHeader={true}/>
        </div>
      </div>
    </div>
  );
};

export default benefits;



// WEBPACK FOOTER //
// ./src/components/Home/Benefits/Benefits.js